export enum TimePeriod {
  daily = 'Today',
  weekly = 'This week',
  monthly = 'This month',
  all = 'All time',
  custom = 'custom period',
}
